import { render, staticRenderFns } from "./BackHead.vue?vue&type=template&id=f8293eea&scoped=true&"
import script from "./BackHead.vue?vue&type=script&lang=js&"
export * from "./BackHead.vue?vue&type=script&lang=js&"
import style0 from "./BackHead.vue?vue&type=style&index=0&id=f8293eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8293eea",
  null
  
)

export default component.exports